import { describeHttpError, isPendingFeature } from '../api/http';
import { Alert, Notice } from './ui';

/**
 * Fallo de la puerta, contado como lo que es.
 *
 * Un panel construido contra un backend que se está escribiendo en paralelo
 * recibe dos cosas muy distintas con la misma pinta: "esto se ha roto" y "esto
 * todavía no existe". Colapsarlas en un mensaje rojo hace que el técnico abra un
 * incidente por una fase pendiente, y que se acostumbre a ignorar los rojos.
 *
 * Un 501 (el OCC no lo ofrece) o un 404 de una ruta que aún no está montada salen
 * en azul y como aviso; todo lo demás —incluido el 409 de "ese agente no sabe
 * hacerlo" y el 503 de "el nodo está apagado"— sale como error, porque hay algo
 * que arreglar.
 */
export function ErrorNotice({
  error,
  what,
  pendingHint,
}: {
  error: unknown;
  /** Qué se estaba intentando, para que el mensaje diga algo sin leer el código. */
  what: string;
  /** Explicación de qué falta y de qué depende, cuando se sabe. */
  pendingHint?: string;
}) {
  const message = describeHttpError(error);

  if (isPendingFeature(error)) {
    return (
      <Notice tone="pending" title={`${what}: todavía no disponible`}>
        {message}
        {pendingHint && <> {pendingHint}</>}
      </Notice>
    );
  }

  return (
    <Alert>
      <strong>{what}:</strong> {message}
    </Alert>
  );
}
